import Head from 'next/head';
import Image from 'next/image';
import useTranslation from '@modules/hooks/useTranslation';
import styles from '@styles/actors/index.module.scss';

interface ReasonType {
    title: string;
    text: string;
}
interface MarketplaceType {
    title: string;
    subTitle: string;
    text: string;
}

const Actors = () => {
    const { t, locale } = useTranslation('actors');

    return (
        <>
            <Head>
                <title>actors | 볼리</title>
                <meta property="og:title" content="actors | 볼리" />
            </Head>

            <div className={styles.banner}>
                <h1>{t('title')}</h1>
                <p>{t('subTitle')}</p>
            </div>

            <p className={styles.notice}>
                {t('bannerText')[0]}
                <br className={styles.mobile} />
                {t('bannerText')[1]}
            </p>

            <section className={styles.section}>
                <p className={styles.title}>
                    {t('reasonsSection').title[0]}
                    <br className={styles.mobile} />
                    {t('reasonsSection').title[1]}
                </p>
                <ul className={styles.list}>
                    {t('reasonsSection').reasons.map((item: ReasonType, index: number) => (
                        <li key={index} className={styles.item}>
                            <span className={styles.no}>{index + 1}</span>
                            <span className={styles.title}>{item.title}</span>
                            <span className={styles.text}>{item.text}</span>
                        </li>
                    ))}
                </ul>
            </section>

            <div className={styles.banner2}>
                <div>
                    <img src="/VOLI-actors.png" alt="VOLI actors" width={110} height={20} />
                </div>
                <span>
                    {t('banner2Text')[0]}
                    <br className={styles.mobile} />
                    {t('banner2Text')[1]}
                </span>
            </div>

            <section className={styles.section}>
                <p className={styles.title}>{t('voiceMarketplaceSection').title}</p>
                <Image src={`/images/actors/tag_${locale}.webp`} alt="" width={960} height={520} loading="eager" />
                <ul className={styles.list}>
                    {t('voiceMarketplaceSection').marketPlace.map((item: MarketplaceType, index: number) => (
                        <li key={index} className={styles.item}>
                            <span className={styles.no}>{index + 1}</span>
                            <span className={styles.title}>
                                {item.title}
                                <span>
                                    &nbsp;&nbsp;&nbsp;
                                    <br className={styles.mobile} />
                                    {item.subTitle}
                                </span>
                            </span>
                            <span className={styles.text}>{item.text}</span>
                        </li>
                    ))}
                </ul>
            </section>

            <section className={styles.voli}>
                <p className={styles.title}>{t('title')}</p>
                <Image src="/VOLI-primary.png" width={151} height={49} />
            </section>
        </>
    );
};

export default Actors;
